export const MAPLECROFT_CORPORATE_LINKED_IN = 'https://www.linkedin.com/company/maplecroft/';
